var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgP2Plunger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 24,
    fill: "none",
    viewBox: "0 0 20 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#CB7569",
    d: "M14 5v19H6V5h8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BE5648",
    d: "M14 5v2H6V5h8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F79689",
    d: "M19.92 5H.16C.08 5 0 5 0 4.878V1s0-1 1-1h18c.81 0 .97.776.995.96a.549.549 0 0 1 .005.08v3.838C20 5 20 5 19.92 5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B84B3D",
    d: "M1 2.5a.5.5 0 1 1 1 0V5H1V2.5zm4 0a.5.5 0 1 1 1 0V5H5V2.5zm4 0a.5.5 0 1 1 1 0V5H9V2.5zm4 0a.5.5 0 0 1 1 0V5h-1V2.5zm4 0a.5.5 0 0 1 1 0V5h-1V2.5zm-14 0a.5.5 0 1 1 1 0V5H3V2.5zm4 0a.5.5 0 1 1 1 0V5H7V2.5zm4 0a.5.5 0 0 1 1 0V5h-1V2.5zm4 0a.5.5 0 0 1 1 0V5h-1V2.5zm4 0a.5.5 0 0 1 1 0V5h-1V2.5z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v24H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgP2Plunger);
export default __webpack_public_path__ + "static/media/P2-Plunger.760aea026d2f0fc3e09aee0e2ae5c82d.svg";
export { ForwardRef as ReactComponent };